module.exports = __webpack_public_path__ + "img/google-login.8ef1f996.webp";